import { truncateToDecimals } from './truncate-to-decimals';

export const formatFileSize = (size: number) => {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${truncateToDecimals(size / 1024)} KB`;
  return `${truncateToDecimals(size / 1024 / 1024)} MB`;
};
